import {
  step2DirtyState,
  step3DirtyState,
  step4DirtyState
} from 'Pages/Workflow/recoil/state/data'
import { pageState } from 'Pages/Workflow/recoil/state/page'
import { useEffect } from 'react'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const useDirtyGuard = () => {
  const step2Dirty = useRecoilValue(step2DirtyState)
  const step3Dirty = useRecoilValue(step3DirtyState)
  const step4Dirty = useRecoilValue(step4DirtyState)

  const setPageState = useSetRecoilState(pageState)

  useEffect(() => {
    /*
    if (step2Dirty || step3Dirty || step4Dirty) {
      setPageState((prev) => ({
        ...prev,
        isDirty: true
      }))
    }
    */
    setPageState((prev) => ({
      ...prev,
      isDirty: step2Dirty || step3Dirty || step4Dirty
    }))
  }, [step2Dirty, step3Dirty, step4Dirty])
}

export default useDirtyGuard
